import React from 'react';
type StatusType = 'pending' | 'pending-collection' | 'shipped' | 'delivered' | 'returned' | 'cancelled' | 'disputing' | 'completed' | 'refunded' | 'closed';
interface OrderStatusBadgeProps {
  status: StatusType;
}
export const OrderStatusBadge = ({
  status
}: OrderStatusBadgeProps) => {
  const getStatusStyles = (status: StatusType) => {
    switch (status) {
      case 'pending':
        return 'bg-purple-100 text-purple-800';
      case 'pending-collection':
        return 'bg-blue-100 text-blue-800';
      case 'shipped':
        return 'bg-orange-100 text-orange-800';
      case 'delivered':
        return 'bg-green-100 text-green-800';
      case 'returned':
        return 'bg-orange-100 text-orange-800';
      case 'cancelled':
        return 'bg-red-100 text-red-800';
      case 'disputing':
        return 'bg-yellow-100 text-yellow-800';
      case 'completed':
        return 'bg-green-100 text-green-800';
      case 'refunded':
        return 'bg-red-100 text-red-800';
      case 'closed':
        return 'bg-gray-100 text-gray-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };
  const formatStatus = (status: string) => {
    return status.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
  };
  return <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusStyles(status)}`} data-id="element-468">
      {formatStatus(status)}
    </span>;
};